import React, { useState } from 'react';
import { useAuth } from '../AuthContext';
import bcrypt from "bcryptjs";

const RegistrationPage = () => {
  const { API_BASE_URL } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    organization: '',
    firstName: '',
    lastName: '',
    password: '',
    confirmPassword: '',
    termsAccepted: true,
  });
  const [text, setText] = useState("");
  const [proof, setProof] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    setSubmitted(false);
    setProof({});
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      alert('Passwords do not match');
      return;
    }
    if (!formData.termsAccepted) {
      alert('You must accept the Terms of Service');
      return;
    }
    handleRegister();
  };

  const handleRegister = () => {
    fetch(API_BASE_URL + 'register', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then((res) => res.json())
      .then((res) => setProof(res))
      .catch((err) => console.error('Error during registration:', err));

  };

  const handleFinalRegister = async () => {
    if (proof.num1 + proof.num2 !== parseInt(text)) {
      return;
    }
    const salt = "$2a$10$1234567890123456789012";
    const pw = await bcrypt.hash(formData.password, salt);
    fetch(API_BASE_URL + 'register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: formData.email,
        organization: formData.organization,
        firstName: formData.firstName,
        lastName: formData.lastName,
        password: pw,
        proof: text,
        session: proof.session,
      }),
    })
      .then((res) => res.json())
      .then(() => setSubmitted(true))
      .catch((err) => console.error('Error during registration:', err));
  };

  const handleInputChange = (event) => {
    setText(event.target.value);
  };

  if (submitted) {
    return <p>Your application will be validated and you will receive a confirmation email in the next 24h.</p>;
  }
  if (proof.num1) {
    return (
      <div>
        <p>To validate your register, enter the result of the following expression:</p>
        <p>{proof.num1} + {proof.num2} =</p>
        <input
          type="text"
          value={text}
          onChange={handleInputChange}
          placeholder="Enter the value"
        />
        <button onClick={handleFinalRegister}>Submit</button>
      </div>
    );
  }


  return (
    <div className="container mt-5">
      <h2>User Registration</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Email Address</label>
          <input
            type="email"
            className="form-control"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Organization</label>
          <input
            type="text"
            className="form-control"
            name="organization"
            value={formData.organization}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">First Name</label>
          <input
            type="text"
            className="form-control"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Last Name</label>
          <input
            type="text"
            className="form-control"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Password</label>
          <input
            type="password"
            className="form-control"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Confirm Password</label>
          <input
            type="password"
            className="form-control"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
        </div>
        {
          //<div className="mb-3 form-check">
          //<input
          //type="checkbox"
          //className="form-check-input"
          //name="termsAccepted"
          //checked={formData.termsAccepted}
          //onChange={handleChange}
          ///>
          //<label className="form-check-label">
          //I accept the <a href="/terms">Terms of Service</a>
          //</label>
          //</div>
        }
        <button type="submit" className="btn btn-primary" >
          Register
        </button>
      </form>
    </div>
  );
};

export default RegistrationPage;
